import en from './en.json'
import pt from './pt.json'
import fr from './fr.json'

export default {
    en, pt, fr
}